import { DataTable } from '~/shared/data-tables/DataTable';
import { DisciplineOptions, FrequencyTypeEnum, FrequencyTypeOptions } from '@generated';
import { DisciplineChip } from '~/libraries/disciplines/DisciplineChip';
import type { DataTableColumnProps } from '~/shared/data-tables/DataTableColumn';
import type { AbbreviatedFrequencyModel } from './types';
import { getFrequencyAbbreviationDateSpan, getFrequencyAbbreviationText } from './useAbbreviateFrequencies';

export function AbbreviatedFrequencyChip({ frequencyTypeId, disciplineId }: { frequencyTypeId: FrequencyTypeEnum; disciplineId: number }) {
	const visitType = FrequencyTypeOptions.find(v => v.id === frequencyTypeId)!;
	const discipline = DisciplineOptions.find(d => d.id === disciplineId)!;
	return <DisciplineChip disciplineId={disciplineId} label={`${discipline.abbreviation} - ${visitType.label}`} />;
}

const columns: DataTableColumnProps<AbbreviatedFrequencyModel>[] = [
	{
		key: 'discipline',
		header: 'Type',
		renderCell: d => <AbbreviatedFrequencyChip {...d} />
	},
	{
		key: 'abbreviatedFrequency',
		header: 'Frequency',
		renderCell: d => <span className="font-bold text-gray-600">{getFrequencyAbbreviationText(d)}</span>
	},
	{
		key: 'dates',
		header: 'Start - End Dates',
		renderCell: d => <span className="text-gray-600">{getFrequencyAbbreviationDateSpan(d)}</span>
	}
];

export function AbbreviatedFrequenciesTable({ rows }: { rows: AbbreviatedFrequencyModel[] }) {
	return <DataTable columns={columns} rows={rows} />;
}
